export default function splitTimelineTitles() {
    var titles = document.querySelectorAll('.hr-timeline-title');
    titles.forEach(function (el) {
        var text = el.textContent || '';
        var pipeIndex = text.indexOf('|');
        if (pipeIndex === -1) return;

        var place = text.substring(0, pipeIndex).trim();
        var role = text.substring(pipeIndex).trim();

        el.textContent = '';

        var placeSpan = document.createElement('span');
        placeSpan.textContent = place + ' ';
        el.appendChild(placeSpan);

        var roleSpan = document.createElement('span');
        roleSpan.className = 'hr-timeline-role';
        roleSpan.textContent = role;
        el.appendChild(roleSpan);
    });
}
